function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
  fill: "#F7931A"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.643 12.2177C17.207 13.9595 14.5401 13.063 13.6682 12.8581L14.4375 9.78443C15.2838 10.015 18.0789 10.3992 17.643 12.2177ZM17.1558 17.1612C16.6685 19.0566 13.4631 18.032 12.4117 17.7759L13.2579 14.3949C14.3093 14.6766 17.6686 15.1889 17.1558 17.1612ZM20.6689 12.2433C20.951 10.3735 19.515 9.37461 17.5917 8.70865L18.2328 6.19851L16.6942 5.81431L16.0787 8.27322C15.6684 8.17077 15.2581 8.06831 14.8478 7.99147L15.4633 5.50695L13.9247 5.12274L13.2836 7.63288C12.9502 7.55604 12.6168 7.4792 12.3091 7.40236L10.1807 6.86447L9.77039 8.50374C9.77039 8.50374 10.9244 8.75988 10.8987 8.78549C11.5142 8.93918 11.6424 9.34899 11.6167 9.68197L10.8987 12.5507C10.95 12.5507 11.0013 12.5763 11.0526 12.6019C11.0013 12.6019 10.95 12.5763 10.8987 12.5507L9.8986 16.572C9.82167 16.7513 9.61652 17.0331 9.20623 16.9306C9.23187 16.9563 8.0779 16.6489 8.0779 16.6489L7.30859 18.4162L9.3088 18.9029C9.69345 19.0053 10.0525 19.0822 10.4115 19.1846L9.77039 21.746L11.309 22.1302L11.9501 19.5945C12.3604 19.6969 12.7707 19.825 13.181 19.9018L12.5399 22.412L14.0785 22.7962L14.7196 20.2604C17.3353 20.7471 19.3098 20.5678 20.1561 18.1857C20.8228 16.2903 20.1304 15.1889 18.7457 14.4717C19.7201 14.2668 20.4638 13.6009 20.6689 12.2433Z",
  fill: "white"
});
function SvgTokenWbtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenWbtc);
export default __webpack_public_path__ + "static/media/token-wbtc.4cf1c302c3c2a010dd39e87de55b6818.svg";
export { ForwardRef as ReactComponent };